import type { Recipe } from '../../domain/recipe';

// DE: Italienische Abendessen; Vollkornnudeln halten die glykämische Last niedrig.
// EN: Italian dinners; wholegrain pasta keeps the glycemic load low.
// prettier-ignore
export const ITALIAN_RECIPES: readonly Recipe[] = [
  {
    id: 'tuna_pasta', name: 'Цільнозернова паста з тунцем і томатами', cuisine: 'italian', meal: 'dinner',
    nameDe: 'Vollkornpasta mit Thunfisch und Tomaten',
    activeMinutes: 10, totalMinutes: 15, baseServings: 4, lunchboxFriendly: true, backupKit: true,
    ingredients: [
      { productId: 'pasta_wholegrain', quantity: 320 }, { productId: 'tuna', quantity: 370 },
      { productId: 'canned_tomatoes', quantity: 800 }, { productId: 'parmesan', quantity: 40 },
      { productId: 'herbs', quantity: 3 }, { productId: 'oil', quantity: 20 },
    ],
    steps: [
      'Зварити пасту.',
      'Прогріти томати з травами 5 хвилин, додати тунець.',
      'Змішати з пастою й посипати сиром.',
    ],
    stepsDe: [
      'Pasta kochen.',
      'Tomaten mit Kräutern 5 Minuten erhitzen, Thunfisch dazugeben.',
      'Mit der Pasta vermengen und mit Käse bestreuen.',
    ],
  },
  {
    id: 'salmon_cream_pasta', name: 'Паста з лососем, шпинатом і вершками', cuisine: 'italian', meal: 'dinner',
    nameDe: 'Pasta mit Lachs, Spinat und Sahne',
    activeMinutes: 10, totalMinutes: 20, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'pasta_wholegrain', quantity: 320 }, { productId: 'salmon', quantity: 500 },
      { productId: 'spinach', quantity: 450 }, { productId: 'cream', quantity: 200 },
      { productId: 'garlic', quantity: 10 }, { productId: 'parmesan', quantity: 40 },
    ],
    steps: [
      'Зварити пасту.',
      'Обсмажити часник і лосось шматочками, додати шпинат.',
      'Влити вершки, прогріти, змішати з пастою й сиром.',
    ],
    stepsDe: [
      'Pasta kochen.',
      'Knoblauch und Lachs in Stücken anbraten, Spinat dazugeben.',
      'Sahne angießen, erhitzen und mit Pasta und Käse vermengen.',
    ],
  },
  {
    id: 'mushroom_risotto', name: 'Різото з грибами та горошком', cuisine: 'italian', meal: 'dinner',
    nameDe: 'Risotto mit Pilzen und Erbsen',
    activeMinutes: 25, totalMinutes: 35, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    ingredients: [
      { productId: 'rice', quantity: 160 }, { productId: 'mushrooms', quantity: 800 }, { productId: 'onion', quantity: 150 },
      { productId: 'parmesan', quantity: 80 }, { productId: 'broth', quantity: 2 }, { productId: 'butter', quantity: 30 },
      { productId: 'peas', quantity: 300 },
    ],
    steps: [
      'Обсмажити цибулю й гриби на маслі.',
      'Додати рис і поступово вливати гарячий бульйон, помішуючи, 18 хвилин.',
      'Додати горошок і сир, дати постояти 2 хвилини.',
    ],
    stepsDe: [
      'Zwiebel und Pilze in Butter anbraten.',
      'Reis dazugeben und unter Rühren 18 Minuten nach und nach heiße Brühe angießen.',
      'Erbsen und Käse unterrühren und 2 Minuten ziehen lassen.',
    ],
  },
  {
    id: 'pea_salmon_risotto', name: 'Різото з горошком і лососем', cuisine: 'italian', meal: 'dinner',
    nameDe: 'Risotto mit Erbsen und Lachs',
    activeMinutes: 15, totalMinutes: 25, baseServings: 4, lunchboxFriendly: true, backupKit: true,
    ingredients: [
      { productId: 'rice', quantity: 120 }, { productId: 'peas', quantity: 450 }, { productId: 'salmon', quantity: 500 },
      { productId: 'parmesan', quantity: 60 }, { productId: 'broth', quantity: 2 },
    ],
    steps: [
      'Залити рис гарячим бульйоном і варити 15 хвилин, часом помішуючи.',
      'Додати горошок і лосось шматочками, варити ще 5 хвилин.',
      'Вмішати сир.',
    ],
    stepsDe: [
      'Reis mit heißer Brühe aufgießen und 15 Minuten kochen, ab und zu umrühren.',
      'Erbsen und Lachs in Stücken dazugeben und weitere 5 Minuten kochen.',
      'Käse unterrühren.',
    ],
  },
  {
    id: 'minestrone', name: 'Мінестроне з квасолею', cuisine: 'italian', meal: 'dinner',
    nameDe: 'Minestrone mit Bohnen',
    activeMinutes: 15, totalMinutes: 35, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'bacon', quantityPerPortion: 30 },
    ingredients: [
      { productId: 'kidney_beans', quantity: 800 }, { productId: 'zucchini', quantity: 500 }, { productId: 'carrot', quantity: 200 },
      { productId: 'onion', quantity: 100 }, { productId: 'canned_tomatoes', quantity: 400 },
      { productId: 'pasta_wholegrain', quantity: 120 }, { productId: 'parmesan', quantity: 60 }, { productId: 'broth', quantity: 2 },
    ],
    steps: [
      'Обсмажити цибулю й моркву, додати кабачок.',
      'Залити 1,2 л бульйону з томатами, варити 10 хвилин.',
      'Додати квасолю й ламану пасту, варити ще 10 хвилин, подавати з сиром.',
    ],
    stepsDe: [
      'Zwiebel und Karotte anbraten, Zucchini dazugeben.',
      'Mit 1,2 l Brühe und den Tomaten aufgießen und 10 Minuten kochen.',
      'Bohnen und gebrochene Pasta dazugeben, weitere 10 Minuten kochen und mit Käse servieren.',
    ],
  },
  {
    id: 'frittata', name: 'Фрітата з кабачком, перцем і фетою', cuisine: 'italian', meal: 'dinner',
    nameDe: 'Frittata mit Zucchini, Paprika und Feta',
    activeMinutes: 15, totalMinutes: 30, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'ham', quantityPerPortion: 50 },
    ingredients: [
      { productId: 'eggs', quantity: 10 }, { productId: 'zucchini', quantity: 500 }, { productId: 'paprika', quantity: 500 },
      { productId: 'feta', quantity: 200 }, { productId: 'spinach', quantity: 450 }, { productId: 'oil', quantity: 20 },
    ],
    steps: [
      'Обсмажити кабачок, перець і шпинат у сковороді, що йде в духовку.',
      'Залити збитими яйцями й посипати фетою.',
      'Запікати 15 хвилин при 200 °C.',
    ],
    stepsDe: [
      'Zucchini, Paprika und Spinat in einer ofenfesten Pfanne anbraten.',
      'Mit verquirlten Eiern übergießen und mit Feta bestreuen.',
      '15 Minuten bei 200 °C backen.',
    ],
  },
  {
    id: 'pasta_ceci', name: 'Паста з нутом і шпинатом', cuisine: 'italian', meal: 'dinner',
    nameDe: 'Pasta mit Kichererbsen und Spinat',
    activeMinutes: 10, totalMinutes: 20, baseServings: 4, lunchboxFriendly: true, backupKit: true,
    ingredients: [
      { productId: 'pasta_wholegrain', quantity: 160 }, { productId: 'chickpeas', quantity: 800 },
      { productId: 'spinach', quantity: 450 }, { productId: 'canned_tomatoes', quantity: 400 },
      { productId: 'parmesan', quantity: 40 }, { productId: 'herbs', quantity: 3 },
    ],
    steps: [
      'Зварити пасту.',
      'Прогріти томати з нутом, шпинатом і травами 10 хвилин.',
      'Змішати з пастою й посипати сиром.',
    ],
    stepsDe: [
      'Pasta kochen.',
      'Tomaten mit Kichererbsen, Spinat und Kräutern 10 Minuten erhitzen.',
      'Mit der Pasta vermengen und mit Käse bestreuen.',
    ],
  },
  {
    id: 'veggie_bake', name: 'Запечені овочі з нутом і моцарелою', cuisine: 'italian', meal: 'dinner',
    nameDe: 'Ofengemüse mit Kichererbsen und Mozzarella',
    activeMinutes: 15, totalMinutes: 40, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'chicken_breast', quantityPerPortion: 100 },
    ingredients: [
      { productId: 'chickpeas', quantity: 800 }, { productId: 'zucchini', quantity: 500 }, { productId: 'paprika', quantity: 500 },
      { productId: 'tomato', quantity: 500 }, { productId: 'mozzarella', quantity: 250 }, { productId: 'herbs', quantity: 3 },
      { productId: 'oil', quantity: 30 },
    ],
    steps: [
      'Нарізати овочі, змішати з нутом, олією й травами.',
      'Запікати 20 хвилин при 220 °C.',
      'Викласти зверху моцарелу й запікати ще 5 хвилин.',
    ],
    stepsDe: [
      'Gemüse schneiden und mit Kichererbsen, Öl und Kräutern vermengen.',
      '20 Minuten bei 220 °C backen.',
      'Mozzarella darauflegen und weitere 5 Minuten backen.',
    ],
  },
  {
    id: 'baked_pasta_broccoli', name: 'Запечена паста з броколі та сиром', cuisine: 'italian', meal: 'dinner',
    nameDe: 'Nudelauflauf mit Brokkoli und Käse',
    activeMinutes: 15, totalMinutes: 40, baseServings: 4, lunchboxFriendly: true, backupKit: false,
    meatAddOn: { productId: 'ham', quantityPerPortion: 50 },
    ingredients: [
      { productId: 'pasta_wholegrain', quantity: 240 }, { productId: 'broccoli', quantity: 1000 },
      { productId: 'cheese', quantity: 160 }, { productId: 'cream', quantity: 200 }, { productId: 'eggs', quantity: 2 },
    ],
    steps: [
      'Зварити пасту, за 3 хвилини до кінця додати броколі.',
      'Змішати вершки з яйцями й половиною сиру.',
      'Залити пасту, посипати рештою сиру й запікати 20 хвилин при 200 °C.',
    ],
    stepsDe: [
      'Pasta kochen und 3 Minuten vor Ende den Brokkoli dazugeben.',
      'Sahne mit Eiern und der Hälfte des Käses verrühren.',
      'Über die Pasta gießen, mit dem restlichen Käse bestreuen und 20 Minuten bei 200 °C backen.',
    ],
  },
];
